import formTagsExtendedEdit from './formTagsExtendedEdit';
import formTagsMainEdit from './formTagsMainEdit';
import formTagsPosterEdit from './formTagsPosterEdit';

export default {
  title: 'Customized Tag',
  attributeName: 'tags',
  getURL: 'tags',
  createURL: 'tags',
  updateURL: 'appId/tags',
  additionaMetadataURL: '',
  removeURL: '',
  canCreate: true,
  idAttribute: 'id',
  sessionParams: ['appId'],
  formConfig: [formTagsMainEdit,formTagsPosterEdit,formTagsExtendedEdit],
  noArea: true,
  goBack: true,
  idUpdate: true,
  saveIdSessionNameAs:'id',
  reconfirmMessage:'Are you sure you want to save this overwritten tag?',
};
